module.exports = __webpack_public_path__ + "img/splash-platform-policy.af0bd20.png";